import React from "react";
import "../styles/Pricing.css";

const pricingPlans = [
  {
    title: "Starter",
    price: "Kostenlos",
    calls: "10.000 API-Aufrufe / Monat",
    description: "Ideal für kleine Projekte und erste Tests.",
    buttonText: "Loslegen",
  },
  {
    title: "Pro",
    price: "€49/Monat",
    calls: "500.000 API-Aufrufe / Monat",
    description: "Perfekt für wachsende Unternehmen mit regelmäßiger Nutzung.",
    buttonText: "Jetzt abonnieren",
  },
  {
    title: "Enterprise",
    price: "Individuell",
    calls: "Unbegrenzte API-Aufrufe",
    description: "Maßgeschneiderte Lösungen für hohe Anforderungen & Unternehmen.",
    buttonText: "Kontakt aufnehmen",
  },
];

export default function Pricing() {
  return (
    <div className="pricing-container">
      <h1 className="pricing-title">Unsere Preise</h1>
      <p className="pricing-subtitle">Flexible Tarife für jeden Bedarf – nur 1 Cent pro API-Aufruf!</p>
      
      <div className="pricing-grid">
        {pricingPlans.map((plan, index) => (
          <div key={index} className="pricing-card">
            <h2 className="plan-title">{plan.title}</h2>
            <p className="plan-price">{plan.price}</p>
            <p className="plan-calls">{plan.calls}</p>
            <p className="plan-description">{plan.description}</p>
            <button className="pricing-button">{plan.buttonText}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
